export default {
  verboseName: "Ruolo di persona",
  verboseNamePlural: "Ruoli di persona",
  modelName: "PersonRole",
  modelNamePlural: "PersonRoles",
  appName: "people",
  propName: "personRole",
  propNamePlural: "personRoles",
}
